import React from 'react'

const AnnualToggle = ({ is_yearly, setIsYearly }) => {
  return (
    <div className="relative flex   w-full md:w-[300px]  p-1 bg-gray-200 rounded">
      <span className="absolute inset-0 m-1 pointer-events-none" aria-hidden="true">
        <span
          className={`absolute inset-0 w-1/2 bg-white rounded shadow transform transition duration-150 ease-in-out ${
            is_yearly ? 'translate-x-0' : 'translate-x-full'
          }`}
        ></span>
      </span>
      <button
        className={`relative flex-1 text-sm font-medium p-1 transition duration-150 ease-in-out ${
          !is_yearly && 'text-gray-500'
        }`}
        onClick={(e) => {
          e.preventDefault()
          setIsYearly(true)
        }}
      >
        Bill Yearly <span className="text-green-500">-45%</span>
      </button>
      <button
        className={`relative flex-1 text-sm font-medium p-1 transition duration-150 ease-in-out ${
          is_yearly && 'text-gray-500'
        }`}
        onClick={(e) => {
          e.preventDefault()
          setIsYearly(false)
        }}
      >
        Bill Monthly
      </button>
    </div>
  )
}

export default AnnualToggle
